<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-task-item-list">
        <i class="far fa-clipboard-list"></i> Task Item List
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-task-item-list">
        <div class="row mt-2">
          <div class="col-12">
            <DataTable ref="dataTable" :columns="taskItemListColumnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="9" :url="taskItemListURL" :filterOptions="taskItemFilterOptions" :displayTools="true" :displayFilters="true" :hasDateRangeFilter="true" :displayExportTools="true" :displayLocationFilter="true" displayLocationFilterField="taskAccountLocationId" exportTitle="Task Item List">
              <template v-slot:title>
                <ContentTitle>Task Item List</ContentTitle>
                <ContentSubTitle>Displays all task items for tasks</ContentSubTitle>
              </template>
              <template v-slot:tools>
                <slot name="tools" />
              </template>
              <template v-slot:row="row">
                <tr :key="row.data.id">
                  <td class="table-data-nav-link">
                    <LinkTask :id="row.data.taskId" :name="row.data.task.sequenceNumber" />
                  </td>
                  <td>
                    {{row.data.task.name}}
                  </td>
                  <td>
                    <LabelBadge :labelClass="`label-taskitem-type-${row.data.type}`">{{ formatLookupName(row.data.type, TaskItemTypeLookup) }}</LabelBadge>
                  </td>
                  <td>
                    <LabelBadge :labelClass="`label-taskitem-status-${row.data.status}`">{{ formatLookupName(row.data.status, TaskItemStatusTypeLookup) }}</LabelBadge>
                  </td>
                  <td>
                    <LabelBadge labelClass="label-despatch-badge">{{row.data.taskTypeName}}</LabelBadge>
                  </td>
                  <td>
                    <LabelAccountLocationBadge :accountLocationId="row.data.taskAccountLocationId" />
                  </td>
                  <td>
                    {{row.data.name}}
                  </td>
                  <td>
                    {{row.data.locationAddress}}
                  </td>
                  <td>
                    {{row.data.primaryUserName}}
                  </td>
                  <td>
                    {{formatDateTime(row.data.startedDate)}}
                  </td>
                  <td>
                    {{formatDateTime(row.data.estimatedArrivalDate)}}
                  </td>
                  <td>
                    {{formatDateTime(row.data.arrivalDate)}}
                  </td>
                  <td>
                    <span v-if="row.data.arrivalDelayMinutes === null">-</span>
                    <span v-else>{{row.data.arrivalDelayMinutes}} Mins</span>
                  </td>
                  <td>
                    {{formatDateTime(row.data.completedDate)}}
                  </td>
                  <td>
                    {{formatDateTime(row.data.leaveDate)}}
                  </td>
                  <td>
                    <span v-if="row.data.leaveDelayMinutes === null">-</span>
                    <span v-else>{{row.data.leaveDelayMinutes}} Mins</span>
                  </td>
                  <td>
                    <span v-if="row.data.onSiteMinutes === null">-</span>
                    <span v-else>{{row.data.onSiteMinutes}} Mins</span>
                  </td>
                </tr>
              </template>
            </DataTable>            
          </div>
        </div>
      </TabPage>
      
    </template>
  </TabbedBox>
</template>


<script>
import _ from 'lodash'

import formMixin from '@/mixins/form'
import Utils from '@/utils/utils'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'

import { TaskItemTypes, TaskItemStatusTypes, TaskItemStatusTypeLookup, TaskItemTypeLookup } from '@/store/types'

export default {
  name: 'TaskReport',
  mixins: [formMixin],
  components: {
    ReportFilterPopover,
    ReportDateRangeSelect,
    ReportFilterGroup
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      userList: [],
      taskTypeList: [],
    }
  },
  computed: {
    taskItemListURL() {
      var params = {
        filter: {}
      }

      return '/intelligence/tasks/taskitems?' + $.param(params)
    },
    taskItemListColumnList() {
      return [
        { title: 'Task', data: 'task.sequenceNumber' },
        { title: 'Task Name', data: 'task.name' },
        { title: 'Type', data: 'type' },
        { title: 'Status', data: 'status' },
        { title: 'Task Type', data: 'taskTypeName' },
        { title: 'Location', data: 'taskAccountLocationName' },
        { title: 'Name', data: 'name' },
        { title: 'Address', data: 'locationAddress' },
        { title: 'Primary User', data: 'primaryUserName' },
        { title: 'Started', data: 'startedDate', type: 'date', dateFilter: true },
        { title: 'Est. Arrival', data: 'estimatedArrivalDate', type: 'date' },
        { title: 'Arrival', data: 'arrivalDate', type: 'date' },
        { title: 'Arrival Delay', data: 'arrivalDelayMinutes', type: 'number' },
        { title: 'Completed', data: 'completedDate', type: 'date', dateFilter: true },
        { title: 'Leave', data: 'leaveDate', type: 'date' },
        { title: 'Leave Delay', data: 'leaveDelayMinutes', type: 'number' },
        { title: 'Time Onsite', data: 'onSiteMinutes', type: 'number' },
      ]
    },
    taskItemFilterOptions() {
      var filterOptions = []

      filterOptions.push({
        name: 'Type',
        field: 'type',
        columnIndex: 0,
        options: [
          { name: Utils.getLookupName(TaskItemTypeLookup, TaskItemTypes.general), value: TaskItemTypes.general, class: 'label-taskitem-type-general' },
          { name: Utils.getLookupName(TaskItemTypeLookup, TaskItemTypes.orderDespatch), value: TaskItemTypes.orderDespatch, class: 'label-taskitem-type-orderDespatch' },
          { name: Utils.getLookupName(TaskItemTypeLookup, TaskItemTypes.stoppage), value: TaskItemTypes.stoppage, class: 'label-taskitem-type-stoppage' },
          { name: Utils.getLookupName(TaskItemTypeLookup, TaskItemTypes.transferInternal), value: TaskItemTypes.transferInternal, class: 'label-taskitem-type-transferInternal' },
          { name: Utils.getLookupName(TaskItemTypeLookup, TaskItemTypes.transferExternal), value: TaskItemTypes.transferExternal, class: 'label-taskitem-type-transferExternal' },
          { name: Utils.getLookupName(TaskItemTypeLookup, TaskItemTypes.transferPickup), value: TaskItemTypes.transferPickup, class: 'label-taskitem-type-transferPickup' },
        ]
      })

      filterOptions.push({
        name: 'Status',
        field: 'status',
        columnIndex: 0,
        options: [
          { name: Utils.getLookupName(TaskItemStatusTypeLookup, TaskItemStatusTypes.pending), value: TaskItemStatusTypes.pending, class: 'label-taskitem-status-pending' },
          { name: Utils.getLookupName(TaskItemStatusTypeLookup, TaskItemStatusTypes.active), value: TaskItemStatusTypes.active, class: 'label-taskitem-status-active' },
          { name: Utils.getLookupName(TaskItemStatusTypeLookup, TaskItemStatusTypes.completed), value: TaskItemStatusTypes.completed, class: 'label-taskitem-status-completed' },
          { name: Utils.getLookupName(TaskItemStatusTypeLookup, TaskItemStatusTypes.cancelled), value: TaskItemStatusTypes.cancelled, class: 'label-taskitem-status-cancelled' }
        ]
      })

      filterOptions.push({
        name: 'Task Types',
        field: 'taskTypeId',
        columnIndex: 1,
        options: this.taskTypeList.map(taskType => {
          return {
              name: taskType.name,
              value: taskType.id,
              class: 'label-despatch-badge'
            }
        })
      })

      filterOptions.push({
        name: 'Primary User',
        field: 'primaryUserId',
        columnIndex: 1,
        options: this.userList.map(user => {
          return {
              name: user.name,
              value: user.id,
              colour: user.highlightColour,
            }
        })
      })

      return filterOptions
    }
  },
  created() {
    this.TaskItemStatusTypeLookup = TaskItemStatusTypeLookup
    this.TaskItemTypeLookup = TaskItemTypeLookup
  },
  mounted() {
    this.requestData()
  },
  beforeDestroy() {
  },
  methods: {
    requestData() {
      Promise.all([
        this.$apiService.userService.getUserList(),
        this.$apiService.tasksService.getTaskTypeList()
      ])
      .then(results => {
        
        this.userList = results[0].data.filter(user => user.isActive && user.isTaskResource)
        this.taskTypeList = results[1].data.filter(taskType => taskType.isActive)
      })
      .catch(error => {
        this.loadingError = this.getRequestError(error)
      })
      .finally(() => {
        this.loading = false
      })
    }
    
  }
}
</script>
